<script>
import Grid from '../Shared/Grid'
import { saveAs } from 'file-saver/FileSaver'
import { toArrayBuffer, formatDate } from 'src/utils'
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
export default {
  name: "AffiliateSchedule",
  components: {
    Grid
  },
  created () {
    this.fetchAffiliates()
    this.$store.dispatch('courses/fetch', {})
  },
  data() {
    return {
      affiliates: [],
      maximized: false,
      currentStep: 'start',
      paginationOptions: {
        rowsPerPage: 10,
        page:1
      },
      columnOptions: [
        { field: 'AGENCY_CODE', name: 'AGENCY_CODE', label: 'Agency Code', sortable: true, filter: null, type: 'string', exception: false },
        { field: 'INSTRUCTOR_1_CLIENT_ID', name: 'INSTRUCTOR_1', label: 'Instructor 1', sortable: true, filter: null, type: 'string', exception: false },
        // { field: 'INSTRUCTOR_2_CLIENT_ID', name: 'INSTRUCTOR_2', label: 'Instructor 2', sortable: true, filter: null, type: 'string', exception: false },
        { field: 'START_DATE_1', name: 'START_DATE_1', label: 'Start Date 1', sortable: true, filter: null, type: 'string', exception: false },
        { field: 'START_TIME_1', name: 'START_TIME_1', label: 'Start Time 1', sortable: true, filter: null, type: 'string', exception: false },
        { field: 'END_DATE_1', name: 'END_DATE_1', label: 'End Date 1', sortable: true, filter: null, type: 'string', exception: false },
        { field: 'END_TIME_1', name: 'END_TIME_1', label: 'End Time 1', sortable: true, filter: null, type: 'string', exception: false },
        { field: 'START_DATE_2', name: 'START_DATE_2', label: 'Start Date 2', sortable: true, filter: null, type: 'string', exception: false },
        { field: 'START_TIME_2', name: 'START_TIME_2', label: 'Start Time 2', sortable: true, filter: null, type: 'string', exception: false },
        { field: 'END_DATE_2', name: 'END_DATE_2', label: 'End Date 2', sortable: true, filter: null, type: 'string', exception: false },
        { field: 'END_TIME_2', name: 'END_TIME_2', label: 'End Time 2', sortable: true, filter: null, type: 'string', exception: false },
        { field: 'CLASS_LOCATION', name: 'CLASS_LOCATION', label: 'Class Location', sortable: true, filter: null, type: 'string', exception: false },
        { field: 'STREET_ADDRESS_1', name: 'STREET_ADDRESS_1', label: 'Agency Street Address 1', sortable: true, filter: null, type: 'string', exception: false },
        { field: 'STREET_ADDRESS_2', name: 'STREET_ADDRESS_2', label: 'Agency Street Address 2', sortable: true, filter: null, type: 'string', exception: false },
        { field: 'CITY', name: 'CITY', label: 'Agency City', sortable: true, filter: null, type: 'string', exception: false },
        { field: 'STATE', name: 'STATE', label: 'Agency State', sortable: true, filter: null, type: 'string', exception: false },
        { field: 'ZIP', name: 'ZIP', label: 'Agency Zip', sortable: true, filter: null, type: 'string', exception: false },
        { field: 'COUNTY', name: 'COUNTY', label: 'Agency County', sortable: true, filter: null, type: 'string', exception: false }
      ]
    }
  },
  computed: {
    ...mapState({
      affiliateScheduleModal: s => s.shared.affiliateScheduleModal,
      affiliateScheduleForm: s => s.reports.affiliateScheduleForm,
      affiliateScheduleList: s => s.reports.affiliateScheduleList,
      selectedSchedules: s => s.reports.selectedSchedules,
      loading: s => s.reports.loading
    }),
    ...mapGetters('courses', ['courseOptions']),
    ...mapGetters('users', [ 'affiliateOptions' ]),
  },
  methods: {
      formattedDate(dateString) {
      var finalDateString;
      var d = new Date(dateString);
      var mm = d.getMonth() + 1;
      var dd = d.getDate();
      var yy = d.getFullYear();
      if (mm < 10) {
        mm = "0" + mm;
      }
      if (dd < 10) {
        dd = "0" + dd;
      }
      finalDateString = mm + "/" + dd + "/" + yy;
      return finalDateString;
    },
    ...mapMutations(["closeModal"]),
    ...mapMutations("reports", [ "changeState", "updateSelectedSchedules", "removeSelectedSchedules", "clearAffiliateScheduleForm", "clearAffiliateScheduleList"]),
    ...mapActions("reports", [ "fetchAffiliateSchedule", "generateAffiliateSchedule", 'fetchCourses']),
    ...mapActions("users", [ "fetchAffiliates" ]),
    toggleMaximized() {
      this.maximized = !this.maximized;
    },
    resetReport() {
      this.clearAffiliateScheduleList()
      this.clearAffiliateScheduleForm()
      this.$refs.stepper.reset()
      this.$store.dispatch('courses/fetch', {})
    },
    getAffiliateCodes() {
      const affiliateRegex = /^(\w\w?\w?) - .+/
      const codes = this.affiliates
        .map(aff => {
          const fields = affiliateRegex.exec(aff)
          if (fields && fields.length === 2) {
            return fields[1] // the affiliate code
          }

          return null
        })
        // q-chips-input allows the user to enter fields that aren't in the dropdown
        // so remove any affiliates that aren't listed
        .filter(code => code !== null)

      return codes
    },
    runReport() {
      const codes = this.getAffiliateCodes()
      this.changeState({
        area: 'affiliateScheduleForm',
        field: 'AFFILIATE_CODES',
        val: codes
      })

      this.fetchAffiliateSchedule()
      .then(response => {
        this.generateReport()
      })
    },
    generateReport () {
      this.generateAffiliateSchedule()
      .then(response => {
        if(response) {
          saveAs(
            new Blob([toArrayBuffer(response.content.data)],
            { type: 'application/octet-stream' }),
            'affiliateSchedule.xlsx'
          )
        }
      })
      .then(() => vm.closeModal('affiliateSchedule'))
    },
    disableNext () {
      switch (this.currentStep) {
        case 'state' :
          return !this.studentCompletionForm.LK_STATE_ID
        case 'course' :
          return !this.studentCompletionForm.COURSE_ID
        case 'date' :
          return !this.studentCompletionForm.START_DATE && this.studentCompletionForm.END_DATE
        default :
          return false
      // if (this.currentStep === 'state') {
      //   return !this.studentCompletionForm.LK_STATE_ID
      // } else if (this.currentStep === 'course') {
      //   return !this.studentCompletionForm.COURSE_ID
      // } else if (this.currentStep === 'date') {
      //   return !this.studentCompletionForm.START_DATE && this.studentCompletionForm.END_DATE
      // } else {
      //   return false
      // }
      }
    },
    searchAffiliates(term, done) {
      const lowerCaseTerm = term.toLocaleLowerCase()
      const terms = this.affiliateOptions.filter(({ label }) =>
        label.toLocaleLowerCase().indexOf(lowerCaseTerm) !== -1
      )

      done(terms)
    },
  }
};
</script>

<template>
  <q-modal class="sl-modal"
  id="affiliateScheduleModal"
  :maximized="currentStep === 'review'"
  :value="affiliateScheduleModal"
  @hide="closeModal('affiliateSchedule')"
  >
    <q-modal-layout>
      <q-toolbar slot="header">
        <q-toolbar-title>
            <q-icon name="fa fa-certificate" /> Affiliate Schedule Report
        </q-toolbar-title>
        <!--<q-icon @click.native="toggleMaximized()" size="20px" class="gt-sm" name="filter_none" />-->
        <q-icon @click.native="closeModal('affiliateSchedule')" name="clear" />
    </q-toolbar>
    <q-stepper ref="stepper" v-model="currentStep" no-header-navigation>
      <q-step name="start" title="Start" order="1">
        <div class="relative-position layout-padding" >
            <div class="sl-row">
              <div class="sl-col-12">
                <p style="max-width:350px; margin:0 auto" class="text-center">This report shows all affiliate schedules for a given date range.</p>
              </div>
            </div>
        </div>
      </q-step>
      <q-step class="" 
        name="course"
        order="2"
        title="Pick a course" 
        done-icon="check"
        subtitle="">
        <div class="relative-position layout-padding" >
            <div class="sl-row sl-vp">
              <div class="sl-col-12 q-pb-lg">
                <p style="max-width:350px; margin:0 auto" class="text-center">Select a course.</p>
              </div>
              <!-- <div class="sl-col-2"> &nbsp; </div> -->
              <div class="sl-col-12">
                <q-select
                  clearable
                  :options="courseOptions"
                  :value="affiliateScheduleForm.COURSE_ID"
                  @input="value => changeState({area:'affiliateScheduleForm', field:'COURSE_ID', val: value})"
                />
              </div>
          </div>
        </div>
      </q-step>
      <q-step 
        name="date"
        title="Date Range"
        order="3">
        <div class="relative-position layout-padding">
          <div class="sl-row sl-vp">
            <div class="sl-col-12">
              <p style="max-width:350px; margin:0 auto" class="text-center">Choose a date range.</p>
            </div>
            <div class="sl-col-6">
              <q-datetime stack-label="Start Date" :value="affiliateScheduleForm.START_DATE" @change="val=>changeState({area:'affiliateScheduleForm', field:'START_DATE', val: val})"/>
            </div>
            <div class="sl-col-6">
              <q-datetime stack-label="End Date" :value="affiliateScheduleForm.END_DATE" @change="val=>changeState({area:'affiliateScheduleForm', field:'END_DATE', val: val})"/>
            </div>
          </div>
        </div>
      </q-step>
      <q-step
        name="agencies"
        title="Select Affiliates"
        order="4">
        <div class="relative-position layout-padding">
          <div class="sl-row sl-vp">
            <div class="sl-col-12 q-pb-lg">
              <p style="max-width:350px; margin:0 auto" class="text-center">Select affiliates.</p>
            </div>
            <!-- <div class="sl-col-2"> &nbsp; </div> -->
            <div class="sl-col-12">
              <q-chips-input v-model="affiliates" placeholder="Start typing an affiliate">
                <q-autocomplete
                  :max-results="30"
                  value-field="label"
                  @search="searchAffiliates"
                />
              </q-chips-input>
            </div>
          </div>
        </div>
      </q-step>
    </q-stepper>
      <q-toolbar slot="footer">
        <q-btn color="red" icon="fa fa-trash" label="Remove Selected" @click="removeSelectedSchedules()" v-if="currentStep === 'review' && selectedSchedules.length > 0"/>&nbsp;
        <q-toolbar-title></q-toolbar-title>
         <q-btn
          color="primary"
          flat
          v-if="currentStep !== 'start'"
          @click="$refs.stepper.previous()"
          label="Back"
        />
        <q-btn
          flat
          class="q-mx-md"
          color="primary"
          v-show="currentStep !== 'agencies' && currentStep !== 'review'"
          @click="$refs.stepper.next()"
          label="Next"
        />
        <q-btn color="green" icon="fa fa-gear" label="Run" @click="runReport()" v-if="currentStep === 'agencies'" :loading="loading"/>&nbsp;
        <!-- <q-btn color="green" icon="fa fa-print" label="Generate" @click="generateReport()" v-if="currentStep === 'review'" />&nbsp; -->
        <q-btn outline color="faded" @click="closeModal('affiliateSchedule')" label="Cancel" />
      </q-toolbar>
    </q-modal-layout>
  </q-modal>
</template>

<style lang="stylus">
  #affiliateScheduleModal
    .q-stepper-step
      width 100%
</style>